<div
    role="button"
    [ngClass]="{'currency-converter widget': true, 'disabled': this.isDisabled}"
    [title]="this.buttonTooltip"
    [@widgetState]="widgetState"
    (keydown.enter)="showCurrencyConverter()"
    tabindex="0">
    <span class="label">
        {{ this.buttonTitle }}
        <finder-font-icon class="icon" name="currency-convertor" size="xs"></finder-font-icon>
    </span>
</div>
